import { SystemStyleObject } from "@chakra-ui/react";

export const filterButtonCss: SystemStyleObject = {
  width: "131px",
  height: "28px",
  borderRadius: "8px",
  padding: "4px 16px",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  backgroundColor: "#FFFFFF",
  boxShadow: "0px 0px 0px 1px #122B6914",
};

export const dateFilterDropDownPopUpMenuContentCss: SystemStyleObject = {
  width: "240px",
  height: "fit-content",
  borderRadius: "8px",
  backgroundColor: "#ffffff",
  border: "1px solid #F2F4F7",
  boxShadow: "0px 12px 16px -4px #10182814",
  padding: "0",
  display: "flex",
  flexDirection: "column",
};

export const customDateRangeFilterBtnCss: SystemStyleObject = {
  display: "none",
};

export const genericCustomDateRangeFilterCss: SystemStyleObject = {
  height: "fit-content",
};
